import {
  NOTE_LIST_REQUEST,
  NOTE_LIST_REQUEST_ERROR,
  NOTE_LIST_REQUEST_SUCCESS,
  NOTE_ADD,
  NOTE_ADD_ERROR,
  NOTE_ADD_SUCCESS,
} from '@/store/actions/note';
import { handleRequestError } from '@/utils/error';

import Repository, { NOTES } from '@/repositories/RepositoryFactory';

const NotesRepository = Repository.get(NOTES);

const state = {
  status: '',
  noteList: [],
  noteMeta: '',
  noteListStatus: '',
};

const getters = {
  noteStatus: state => state.status,
  noteList: state => state.noteList,
  noteMeta: state => state.noteMeta,
  noteListStatus: state => state.noteListStatus,
};

const actions = {
  [NOTE_LIST_REQUEST]: async ({ commit }, payload) => {
    commit(NOTE_LIST_REQUEST);
    try {
      const response = await NotesRepository.get(payload);
      commit(NOTE_LIST_REQUEST_SUCCESS, response.data);
    } catch (error) {
      commit(NOTE_LIST_REQUEST_ERROR);
      handleRequestError(error);
    }
  },
  [NOTE_ADD]: async ({ commit }, payload) => {
    commit(NOTE_ADD);
    try {
      const response = await NotesRepository.create(payload);
      commit(NOTE_ADD_SUCCESS, response.data.data);
    } catch (error) {
      commit(NOTE_ADD_ERROR);
      handleRequestError(error);
    }
  },
};

const mutations = {
  [NOTE_LIST_REQUEST]: state => {
    state.noteListStatus = 'loading';
  },
  [NOTE_LIST_REQUEST_SUCCESS]: (state, payload) => {
    state.noteListStatus = 'success';
    state.noteList = payload.data;
    state.noteMeta = payload.meta;
  },
  [NOTE_LIST_REQUEST_ERROR]: state => {
    state.noteListStatus = 'error';
  },
  [NOTE_ADD]: state => {
    state.status = 'loading';
  },
  [NOTE_ADD_SUCCESS]: (state, payload) => {
    state.status = 'success';
    state.noteList.unshift(payload);
  },
  [NOTE_ADD_ERROR]: state => {
    state.status = 'error';
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
